import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Group from '../../../components/form/elements/group';
import Form from '../../../components/form';
import { useService } from '../../../services/services';
import Readonly from '../../../components/form/elements/readonly';
import Title from '../../../components/common/title';
import ClassifierValue from '../../../interfaces/classifierValue';
import { ClassifierManager } from './libs/classifierManager';

export default function ViewClassifierValueInfo({
  id,
  groupKey,
}: {
  id: string;
  groupKey: string;
}) {
  const { t } = useTranslation();
  const { internalClassifierService } = useService();
  const [bodyElements, setBodyElements] = useState([]);
  const [classifierValue, setClassifierValue] = useState(null);
  const [title, setTitle] = useState('');

  useEffect(() => {
    const subscription = internalClassifierService
      .value(groupKey, id)
      .subscribe(async (classifierValue: ClassifierValue) => {
        let classifier = classifierValue.classifier;

        let cManager = new ClassifierManager(
          classifier,
          internalClassifierService,
          (key: string) => {
            return t(key);
          },
          true
        );

        setBodyElements([Readonly([Group(await cManager.getFormFields())])]);

        setTitle(classifier.name);

        classifierValue.properties = cManager.getPropertyValues(
          classifierValue,
          true
        );

        setClassifierValue(classifierValue);
      });

    return () => subscription.unsubscribe();
  }, [
    id,
    internalClassifierService,
    setClassifierValue,
    setBodyElements,
    t,
    groupKey,
  ]);

  return (
    <div>
      <Title title={title} />
      <Form
        title={
          classifierValue
            ? classifierValue.value
            : t('classifiers.edit_form_title')
        }
        mode={'view'}
        body={bodyElements}
        values={classifierValue}
      />
    </div>
  );
}
